/** Tiny status footer shown below the sign-in form. */
export function AuthFooterBar() {
  return (
    <footer className="flex items-center justify-between px-6 sm:px-10 lg:px-14 h-12 border-t border-white/45 text-[11px] text-ink-500">
      <span className="text-ink-400">Jewelitt</span>
      <div className="flex items-center gap-5">
        <a href="#" className="hover:text-ink-900 transition-colors">
          Privacy
        </a>
        <a href="#" className="hover:text-ink-900 transition-colors">
          Terms
        </a>
        <a href="#" className="hover:text-ink-900 transition-colors">
          Status
        </a>
      </div>
    </footer>
  );
}
